import React from 'react';
import { AlertTriangle, Loader2 } from 'lucide-react';
import parse from 'html-react-parser';

interface ConfirmationModalProps {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: () => void;
    onConfirmSingleEvent?: () => void; // Nueva función para solo este evento
    confirmMessage: string;
    showOptions?: boolean; // Para mostrar las dos opciones
    isLoading?: boolean; // Para mostrar estado de carga
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({ 
    isOpen, 
    onClose, 
    onConfirm, 
    onConfirmSingleEvent,
    confirmMessage,
    showOptions = false,
    isLoading = false 
}) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
            <div className="bg-white p-6 rounded-lg max-w-md w-full">
                <div className="flex items-center mb-4">
                    <AlertTriangle size={32} className="text-yellow-500 mr-3" />
                    <h2 className='font-bold text-lg'>CONFIRMACIÓN</h2>
                </div>
                <div className="mb-5">{parse(confirmMessage)}</div>
                
                {showOptions ? (
                    <div className="flex flex-col gap-3">
                        <button 
                            onClick={onConfirmSingleEvent} 
                            className="py-2.5 px-4 bg-blue-500 text-white rounded hover:bg-blue-600 w-full"
                        >
                            Solo este evento
                        </button>
                        <button 
                            onClick={onConfirm} 
                            className="py-2.5 px-4 bg-yellow-500 text-white rounded hover:bg-yellow-600 w-full"
                        >
                            Este y todos los eventos futuros similares
                        </button>
                        <button 
                            onClick={onClose} 
                            className="py-2 px-4 bg-gray-300 rounded hover:bg-gray-400 w-full mt-2"
                        >
                            Cancelar
                        </button>
                    </div>
                ) : (
                    <div className="flex justify-end gap-3">
                        <button 
                            onClick={onClose} 
                            className="py-2 px-4 bg-gray-300 rounded hover:bg-gray-400 disabled:opacity-50"
                            disabled={isLoading}
                        >
                            Cancelar
                        </button>
                        <button 
                            onClick={onConfirm} 
                            className="py-2 px-4 bg-red-500 text-white rounded hover:bg-red-600 disabled:opacity-50 flex items-center"
                            disabled={isLoading}
                        >
                            {isLoading ? (
                                <>
                                    <Loader2 size={16} className="animate-spin mr-2" />
                                    Procesando...
                                </>
                            ) : (
                                'Confirmar'
                            )}
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
};

export default ConfirmationModal;